import { Link } from 'react-router-dom';
import CasinoGameCard from './CasinoGameCard';
import { CasinoGame } from '@/types/casino';

interface Props {
  sections: {
    title: string;
    games: CasinoGame[];
  }[];
  isLoading?: boolean;
  onGameClick?: (game: CasinoGame) => void;
}

export default function CasinoGameGrid({ sections, isLoading = false, onGameClick }: Props) {
  if (isLoading) {
    return (
      <div className="flex-1">
        <div className="h-[2.125rem] w-40 animate-pulse rounded bg-gradient-to-r from-slate-200 via-gray-100 to-gray-200" />
        <div className="mt-2 grid grid-cols-3 gap-x-2 gap-y-2">
          {Array.from({ length: 16 }).map((_, index) => (
            <div
              key={index}
              className="aspect-square overflow-hidden rounded-lg bg-[#e6e8e9] shadow-sm"
            >
              <div className="h-full w-full animate-pulse bg-gradient-to-r from-slate-200 via-gray-100 to-gray-200" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (sections.length === 0) {
    return (
      <div className="flex-1 rounded-xl bg-white px-4 py-8 text-center text-base font-medium text-slate-500">
        No casino games available for this category.
      </div>
    );
  }

  return (
    <div className="flex-1 space-y-1">
      {sections.map((section) => (
        <section key={section.title}>
          <header className="mb-2 flex h-[2.125rem] items-center font-bold">
            <div className="mr-3 h-5 w-1 rounded-lg bg-black" />
            <span className="text-lg text-black">{section.title}</span>
          </header>

          <div className="grid grid-cols-3 gap-2">
            {section.games.map((game) => (
              <CasinoGameCard key={game.id} game={game} onClick={onGameClick} />
            ))}
          </div>
        </section>
      ))}

      <div className={'flex justify-center py-4'}>
        <Link
          to={'/casino'}
          className="px-4 py-1.5 font-medium rounded flex gap-x-3 justify-center items-center
               bg-black/85 text-white"
        >
          Show More <i className="icon-arrow-down -rotate-90 text-base" />
        </Link>
      </div>
    </div>
  );
}
